module.exports = __webpack_public_path__ + "static/img/dsjy-logo.c66ed51c.png";